import { Component, OnInit } from '@angular/core';
import { Util } from '../../util';
import { ConfigService } from 'src/app/services/config.service';
import { Meta } from '@angular/platform-browser';
import { BroadcastService } from '../../services/broadcast.service';

@Component({
  selector: 'smart-banner',
  templateUrl: './smart-banner.component.html',
  styleUrls: ['./smart-banner.component.scss'],
})
export class SmartBannerComponent implements OnInit {
  isSmartBannerOpen = false;
  smartBannerAndroid: string;
  smartBannerIos: string;
  appName: string;
  authorName: string;
  price: string;
  iconUrl: string;
  buttonTxt: string;
  playStoreUrl: string;
  isIOSDevice: RegExpMatchArray | boolean;
  notDesktopDevice: RegExpMatchArray | boolean;
  isAndroidDevice: RegExpMatchArray;

  constructor(
    configService: ConfigService,
    private meta: Meta,
    private broadcastService: BroadcastService
  ) {
    this.smartBannerAndroid = configService.smartBannerAndroid;
    this.smartBannerIos = configService.smartBannerIos;
    this.isIOSDevice = configService.isIOSDevice();
    this.notDesktopDevice = configService.notDesktopDevice();
    this.isAndroidDevice = configService.isAndroidDevice();
    if (this.smartBannerAndroid) {
      const smartArray = this.smartBannerAndroid.split(';');
      if (smartArray.length === 7) {
        this.appName = smartArray[0];
        this.authorName = smartArray[1];
        this.price = smartArray[2] + smartArray[3];
        this.iconUrl = smartArray[4];
        this.buttonTxt = smartArray[5];
        this.playStoreUrl = smartArray[6];
      }
    }
  }

  ngOnInit() {
    if (Util.getCookie('smart_banner') == null && this.notDesktopDevice) {
      if (this.isAndroidDevice && this.smartBannerAndroid) {
        this.isSmartBannerOpen = true;
      } else if (this.isIOSDevice && this.smartBannerIos) {
        this.price = 'Gratis - En Apple Store';
        this.playStoreUrl = 'https://apps.apple.com/es/app/id' + this.smartBannerIos;
        this.isSmartBannerOpen = true;
      }
    }
  }

  saveCookieNoBanner() {
    this.isSmartBannerOpen = false;
    //La cookie caduca en 30 días
    Util.setCookie('smart_banner', 'No', 30);
    this.broadcastService.broadcastDisabledSmartBanner(false);
  }

  goToMarkt() {
    this.saveCookieNoBanner();
    window.location.replace(this.playStoreUrl);
  }
}
